import {
  useEmailTemplateList,
  useMutationDeleteEmailTemplate,
} from "@gymflow/api";
import { isMobile } from "@gymflow/common";
import { cn } from "@gymflow/helpers";
import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { ToastContext } from "apps/portal/src/providers/ToastProvider/context";
import { ModalContext } from "apps/portal/src/providers/ModalProvider";

import { ConfirmModal } from "../templates";
import { EmailTemplateSidebar } from "../organisms";
import { ResourceTableCard } from "../ResourceTableCard";
import useGymflowModels from "../../store";
import { isAxiosError } from "axios";

export function Templates() {
  const [isEmailTemplateSidebarVisible, setIsEmailTemplateSidebarVisible] =
    useState(false);
  const [templateId, setTemplateId] = useState();

  const { api } = useGymflowModels();
  const { setModal, hide } = useContext(ModalContext);
  const { notifyDanger } = useContext(ToastContext);
  const { t } = useTranslation();
  const { mutateAsync: mutateAsyncDeleteEmailTemplate } =
    useMutationDeleteEmailTemplate({ api });

  const renderButtons = ({ resource: { id, isEditable }, beingEdited }) => (
    <div className="flex items-center gap-2">
      <div
        className={cn("text-primary-700 cursor-pointer text-sm font-semibold", {
          hidden: !isEditable || beingEdited,
        })}
        onClick={() => {
          setTemplateId(id);
          setIsEmailTemplateSidebarVisible(true);
        }}
      >
        {t("common.edit")}
      </div>
      <div
        className="text-error-500 cursor-pointer text-sm font-semibold"
        onClick={() => {
          setModal(
            <ConfirmModal
              title={t(
                "page.marketing.templates.table.actions.delete.confirmModal.title",
              )}
              type="danger"
              onConfirm={async () => {
                try {
                  await mutateAsyncDeleteEmailTemplate({ emailTemplateId: id });
                } catch (e) {
                  if (isAxiosError(e)) {
                    notifyDanger(e);
                  }
                }
                hide();
              }}
              onCancel={() => {
                hide();
              }}
            >
              {t(
                "page.marketing.templates.table.actions.delete.confirmModal.description",
              )}
            </ConfirmModal>,
          );
        }}
      >
        {t("common.delete")}
      </div>
    </div>
  );

  return (
    <>
      <EmailTemplateSidebar
        isVisible={isEmailTemplateSidebarVisible}
        templateId={templateId}
        title={
          templateId
            ? t("page.marketing.templates.emailTemplateSidebar.title.edit")
            : t("page.marketing.templates.emailTemplateSidebar.title.add")
        }
        onClose={() => {
          setTemplateId(undefined);
          setIsEmailTemplateSidebarVisible(false);
        }}
      />
      <div className="relative mt-12 flex h-full max-h-full w-full flex-col">
        <Button
          color="primary"
          size="sm"
          className="absolute right-0 top-[-60px] w-fit"
          onClick={() => setIsEmailTemplateSidebarVisible(true)}
        >
          Create Template
        </Button>
        <ResourceTableCard
          columns={[
            {
              accessor: "templateName",
              Header: "Name",
            },
            {
              accessor: "templateType",
              Header: "Type",
              show: !isMobile(),
            },
            {
              Header: "Actions",
              accessor: "actions",
              sortable: false,
              filterable: false,
              minWidth: isMobile() ? 110 : 160,
            },
          ]}
          renderButtons={renderButtons}
          useQueryHook={useEmailTemplateList}
          selectedId={templateId}
          findParams={{ extraParams: { isAutomationTemplate: false } }}
        />
      </div>
    </>
  );
}
